import { AfterContentInit, Component } from "@angular/core";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import { DomSanitizer, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
// @ts-ignore
import _ from "lodash";
import { AlertService } from "src/app/services/alert.service";
import { AuthService } from "src/app/services/auth.service";
import { LoaderService } from "src/app/services/loader.service";
import { LivecoAPIService } from "src/app/services/liveco-api.service";

import { NotificationsService } from "src/app/services/notifications.service";
import { AbstractSplitView } from "../abstract-split-view/abstract-split-view";
import { ProofreadingService } from "src/app/services/proofreading.service";
import { StateMachineService } from "src/app/services/machine-state.service";
import { ProjectService } from "src/app/services/project.service";
import { MembersService } from "src/app/services/member.service";
import { TranslateService } from "@ngx-translate/core";
import { MarqueService } from "src/app/services/marque.service";

@Component({
    selector: "app-split-view-intern",
    templateUrl: "./split-view-intern.html",
    styleUrls: ["./split-view-intern.scss"],
})
export class SplitViewInternComponent extends AbstractSplitView {

    toggleTextFull: boolean = false;
    get fullWidth(): any {
        return this.toggleTextFull || this.cantReadProofscope || !this.url_intern;
    }

    get readOnlyMembers(): boolean {
        return !(this.s_auth.isCPP() || this.s_auth.isFab() || this.current_member?.hasApproDocument);
    }

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected sanitizer: DomSanitizer,
        protected s_alert: AlertService,
        protected dialog: MatDialog,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected title: Title,
        protected liveco: LivecoAPIService,
        protected proofreadings: ProofreadingService,
        protected notifications: NotificationsService,
        protected s_sm: StateMachineService,
        public s_proofreadings: ProofreadingService,
        protected s_projects: ProjectService,
        protected s_members: MembersService,
        protected translate: TranslateService,
        protected s_marques: MarqueService
    ) {
        super(title, route, router, s_alert, s_loader, s_auth, liveco, s_sm, s_proofreadings, s_projects, s_members, sanitizer, s_marques);
    }
}
